import store from '@/state/store'

const maintenanceUnlockPath = process.env.VUE_APP_MAINTENANCE_UNLOCK_PATH || "/maintenance-unlock/9b4d7f2e-6a31-4c8f-a5e9-1d73b0f6c28a-7f3a9c2e5b8d4f1a6c9e2b7d5f8a3c6e1b4d7f9a2c5e8b3d6f1a"

export default [

  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: false,
    },
    component: () => {

      return import('./views/dashboards/default')

      // var userRole = ('; '+document.cookie).split(`; userr=`).pop().split(';')[0];
      
      
      // if (!userRole || userRole == 0) {
      //   return import('./views/dashboards/default');
      // } else  if (userRole == 1) {
      //   return import('./views/reporting/reporting')
      // }
      
      
      
      // else if (userRole == 1) {
      //   /*return import('./views/reporting/supplier-reporting');*/ return import('./views/dashboards/default');
      // }else if(userRole == 2){
      //   /*return import('./views/dashboards/admin');*/ return import('./views/dashboards/default');
      // }

      
    }
  },


  {
    path: '/catalogue',
    name: 'catalog',
    meta: { authRequired: true },
    props(route) {
      return {propFilter: (String) (route.query.filter), propGroup: (Number) (route.query.group), propSubGroup: (Number) (route.query.subgroup)}
    },
    component: () => import('./views/orders/newOrder')
  },

  {
    path: '/claim',
    name: 'Reclamations',
    meta: { authRequired: true },
    props(route){
      return {blNumber: (String) (route.query.blNumber) }
    },
    component: () => import('./views/claim/claim')
  },

  {
    path: '/qrc/claim',
    name: 'QR Code Reclamations',
    meta: { authRequired: false },
    props(route){
      return {codclt: (String) (route.query.codclt),blnum: (String) (route.query.blnum),ts: (String) (route.query.ts) }
    },
    beforeEnter: (to, from, next) => {
    if (process.env.VUE_APP_FEATURE_ENABLE_QRC_CLAIM === 'true') {
      next(); 
    } else {
      next('/404');
    }
  },
  component: () => import('./views/claim/qrcClaim')
  },


  {
    path: '/profil',
    name: 'Gestion de Profile',
    meta: { authRequired: true },
    component: () => import('./views/account/profil')
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: maintenanceUnlockPath,
    name: 'maintenance-unlock',
    meta: { authRequired: false },
    component: () => import('./views/account/maintenance-unlock')
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/')
        )

        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },




  // {
  //   path: '/banners',
  //   name: 'Admin Banners',
  //   meta: { authRequired: true },
  //   component: () => import('./views/admin/banners')
  // },

  {
    path: '/bannieres',
    name: 'Bannières',
    meta: { authRequired: true },
    component: () => import('./views/banner-news/banners-news')
  },

  {
    path: '/utilisateurs',
    name: 'liste des utilisateurs',
    meta: { authRequired: true },
    component: () => import('./views/admin/listOfUsers')
  },
  {
    path: '/customer-utilisateurs',
    name: 'liste-des-utilisateurs',
    meta: { authRequired: true },
    props(route) {
      return {customerId: (Number) (route.query.id) }
    },
    component: () => import('./views/customer-admin/customerAdmin')
  },


 

  // {
  //   path: '/articles',
  //   name: 'Add Items',
  //   meta: { authRequired: true },
  //   component: () => import('./views/stock/addNewItems')
  // },

  {
    path: '/commandes',
    name: 'Liste des Commandes',
    meta: { authRequired: true },
    component: () => import('./views/ordersMenu/index')
  },

  {
    path: '/orders/order',
    name: 'Order',
    props(route) {
      return {  orderId: (Number) (route.query.orderId) }
    },
    meta: { authRequired: true },
    component: () => import('./views/orders/order')
  },

  {
    path: '/reporting',
    name: 'Rapports & Stats',
    meta: { authRequired: true },
    component: () => import('./views/reporting/reporting')
  },

  {
    path: '/reporting-partner',
    name: 'Rapports Frs',
    meta: { authRequired: true },
    component: () => import('./views/reporting/reporting-partner')
  },

  {
    path: '/bc-frs-partner',
    name: 'Rapports Frs',
    meta: { authRequired: true },
    component: () => import('./views/reporting/bc-partner')
  },

]
